export default __webpack_public_path__ + "static/compareItemImg4-d44c1077a3640d3369580d820e88bb03.png";